import { create } from "zustand"

import { EGameScene } from "../type"

interface IGameLayerStore {
    nextScene: () => boolean
    changeScene: (scene: EGameScene) => boolean
    setNextScene: (value: () => boolean) => void
}

export const useGameLayerStore = create<IGameLayerStore>((set) => ({
    nextScene: () => false,
    changeScene: (value) => false,
    setNextScene: (value: () => boolean) => set({ nextScene: value }),
}))

export const useNextScene = () => useGameLayerStore((state) => state.nextScene)
